import React from 'react'
import Title from './../UI/Title';

const Environment = () => (
  <div>
    <Title>
      איכות הסביבה
    </Title>
    
  </div>
)

export default Environment
